export const projects = [
  {
    img: "https://oneword.domains/_next/image?url=https%3A%2F%2Fres.cloudinary.com%2Fowd-assets%2Fimage%2Fupload%2Fv1672929433%2Fclcj6zhvn0001l108h8x13u2i.png&w=1200&q=75",
    title: "GETHARVEST-Clone",
    des: "Harvest offers time tracking, invoicing, expense tracking, and time-based reporting. Users can send automated payment reminders from the software if clients haven't paid an invoice on time.This was a collaborative project built by team of 4 members in 5 days.",
    demo: "",
    live: "https://masai-getharvest-clone.netlify.app/",
    gitHub: "https://github.com/prabhatm39/smooth-dock-1057",
    technologies: [
      "HTML",
      "CSS",
      "JavaScript",
      "React","Chakra-UI","Mongodb","Express.Js","Node.js","Heroku"
      
    ],
  },
  {
    img: "https://thebrandreality.com/wp-content/uploads/2022/05/The-BR-Blog-Banners-9.png",
    title: "Coschedule-Clone",
    des: "CoSchedule is the marketing industry's leading provider of content calendar, content optimization and marketing education products. This was a collaborative project buit by team of 5 members in 5 days.",
    
    demo: "",
    live: "https://coscheduleclonebymuffi.netlify.app/",
    gitHub: "https://github.com/sangle2022/ripe-receipt-7221",
    technologies: ["HTML", "CSS", "JavaScript","React", "Chakra UI"],
  },
  
  {
    img: "https://ankitchaurasia.netlify.app/images/portfolio/modals/shop.PNG",
    title: "Shop.com-Clone",
    des: "This is a team project where we cloned most of the pages of shop.com website. Shop.com is an e-commerce website from where one can buy clothing and beauty related products.",
    demo: "",
    live: "https://stunning-gecko-ff6621.netlify.app/",
    gitHub: "https://github.com/sangle2022/Shop.com-clone",
    technologies: [
      "HTML",
      "CSS",
      "JavaScript"
      
    ],
  }];
